<template>
	<v-container fluid>
		<v-data-table
	    :headers="headersGrupos"
	    :items="filterPagosGruposList"
	    class="elevation-0"
	    :search="search"
	    :mobile-breakpoint="100"
	    dense
	  >
	    <template v-slot:item.forma_pago="{ item }">
	    	<v-btn
	    		outlined
	    		color="green"
	    		x-small
	    		v-if="item.forma_pago == 1"
	    	>Efectivo</v-btn>

	    	<v-btn
	    		outlined
	    		color="orange"
	    		x-small
	    		v-if="item.forma_pago == 2"
	    	>Deposito</v-btn>

	    	<v-btn
	    		outlined
	    		color="red"
	    		x-small
	    		v-if="item.forma_pago == 3"
	    	>Tarjeta</v-btn>
	    </template>

	    <template v-slot:item.detalles="{ item }">
	    	{{ item.detalle_articulo }}
	    </template>


	    <template v-slot:item.folio2="{ item }">
	    	{{ item.iniciales + '-' + item.idpagos_grupos_detalles }}
	    </template>

	    <template v-slot:item.folio3="{ item }">
	    	{{ item.iniciales + '-' + item.idingresos_paquetes }}
	    </template>

	    <template v-slot:item.folio4="{ item }">
	    	{{ item.iniciales + '-' + item.idpagos_articulos }}
	    </template>

	    <template v-slot:item.pagado="{ item }">
	    	{{ format( item.pagado ) }}
	    </template>

	    <template v-slot:item.actions="{ item }">

	    	<v-btn
	    		color="blue"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="verDetalleArticulo( item )"
	    		v-if="[2,3,4].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-eye</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="red"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="verPdf( item )"
	    		v-if="[1].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-file-pdf-box</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="red"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="verPdfPaquete( item )"
	    		v-if="[2,4].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-file-pdf-box</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="red"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="verPdfArticulo( item )"
	    		v-if="[3].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-file-pdf-box</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="green"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="convertPdf( item )"
	    		v-if="[1].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-whatsapp</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="green"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="convertPdfArt( item )"
	    		v-if="[3].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-whatsapp</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="green"
	    		x-small
	    		class="mr-2"
	    		icon
	    		@click="convertPdf2( item )"
	    		v-if="[2,4].includes( tipoPago )"
	    	>
	    		<v-icon>mdi-whatsapp</v-icon>
	    	</v-btn>

	    	<v-btn
	    		color="red"
	    		x-small
	    		icon
	    		@click="$emit('deleteItem', item, tipoPago )"
	    	>
	    		<v-icon>mdi-delete</v-icon>
	    	</v-btn>
	    </template>

	    <template v-slot:item.pagado="{ item }">
	    	{{ format( item.pagado ) }}
	    </template>

	  </v-data-table>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialogVerArticulos"
      max-width="1000px"
    >
      <v-card v-if="detalleArticulos || detallePaquetes">
      	<v-card-title>
      		Datos de pago
      	</v-card-title>
      	<v-card-text>
      		<v-row>
      			<v-col cols="12">
      				<v-list class="transparent">
					      <v-list-item>
					        <v-list-item-title>Alumno</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ tipoPago == 3 ? detalleArticulos.alumno : detallePaquetes.alumno }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Forma de pago</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>
					          	<v-btn
								    		outlined
								    		color="green"
								    		x-small
												v-if="( detalleArticulos && detalleArticulos.forma_pago == 1 ) || ( detallePaquetes && detallePaquetes.forma_pago == 1)">
								    	>Efectivo</v-btn>

								    	<v-btn
								    		outlined
								    		color="orange"
												v-if="( detalleArticulos && detalleArticulos.forma_pago == 2 ) || ( detallePaquetes && detallePaquetes.forma_pago == 2)">
								    		x-small
								    	>Deposito</v-btn>

								    	<v-btn
								    		outlined
								    		color="red"
												v-if="( detalleArticulos && detalleArticulos.forma_pago == 3 ) || ( detallePaquetes && detallePaquetes.forma_pago == 3)">
								    		x-small
								    	>Tarjeta</v-btn>
					          </b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Plantel</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ tipoPago == 3 ? detalleArticulos.plantel : detallePaquetes.plantel }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Pagado</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ tipoPago == 3 ? format( detalleArticulos.pagado ) : format( detallePaquetes.pagado ) }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					      <v-list-item>
					        <v-list-item-title>Fecha de pago</v-list-item-title>
					        <v-list-item-subtitle class="text-right black--text">
					          <b>{{ tipoPago == 3 ? detalleArticulos.fecha_creacion : detallePaquetes.fecha_creacion }}</b>
					        </v-list-item-subtitle>
					      </v-list-item>
					      <v-divider></v-divider>

					    </v-list>
      			</v-col>

				  	<v-col cols="12" lg="12">
				    	<v-data-table
				        :headers="headersArticulos"
				        :items="detalleArticulos.detalles"
				        class="elevation-0"
				        :mobile-breakpoint="100"
				        hide-details
				        hide-default-footer
				        dense
				        v-if="tipoPago == 3"
				      >
				      </v-data-table>

				      <v-data-table
				        :headers="headersPaquetes"
				        :items="detallePaquetes.detalles"
				        class="elevation-0"
				        :mobile-breakpoint="100"
				        hide-details
				        hide-default-footer
				        dense
				        v-if="tipoPago == 2"
				      >
				      </v-data-table>
		        </v-col>
      		</v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>
		
	</v-container>
</template>

<script>
	// Componentes
	export default {
		props:[
			'headersGrupos',
			'filterPagosGruposList',
			'search',
			'tipoPago'
		],

    data: () => ({
      // herramientas visuales
      dialogVerArticulos: false,

      detalleArticulos: null,

      detallePaquetes: null,

      headersArticulos: [
        { text: 'ID'       , value: 'idarticulos' },
        { text: 'Nombre'   , value: 'articulo'    },
        { text: 'Costo'    , value: 'costo'       },
        { text: 'Cantidad' , value: 'cantidad'    },
        { text: 'Costo T.' , value: 'costo_total' },
      ],

      headersPaquetes: [
        { text: 'ID'       , value: 'idpaquetes' },
        { text: 'Nombre'   , value: 'nombre' },
        { text: 'Costo'    , value: 'costo' },
        { text: 'Cantidad' , value: 'cantidad' },
        { text: 'Costo T.' , value: 'costo_total' },
      ],

    }),

    computed: {
    
    },

    async created() {

    },


    methods: {
      format( valor ){
	      return valor.toLocaleString('es-MX', {
	        style: 'currency',
	        currency: 'MXN'
	      });
	    },

	    verDetalleArticulo( item ){

	    	if( this.tipoPago == 1 ){

	    	}

	    	if( this.tipoPago == 2 ){
	    		this.dialogVerArticulos = true
	    		this.detallePaquetes = item
	    	}

	    	if( this.tipoPago == 3 ){
	    		this.detalleArticulos = item
	    		this.dialogVerArticulos = true
	    	}

	    	if( this.tipoPago == 4 ){
	    		this.detalleArticulos = item
	    		this.dialogVerArticulos = true
	    	}

	    },

	    async convertPdf( item ){

	      this.cargar = true;

			  try {


			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('colegiatura.alumno.pdf' , item );

			    const numero = `521${item.telefono}`; // Cambia al número deseado
		      const linkArchivo = `https://sofsolution.club/api-enlace/download-imagenes/${item.idpagos_grupos_detalles}`;
		      const mensaje = `Puedes descargar el comprobante de tu pago en el siguiente enlace: ${linkArchivo}`;

		      const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

			async convertPdfArt( item ){

	      this.cargar = true;

			  try {


			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('colegiatura.alumno.pdf' , item );

			    const numero = `521${item.telefono}`; // Cambia al número deseado
		      const linkArchivo = `https://sofsolution.club/api-enlace/pdf_pagos/${item.idpagos_articulos}-articulos.pdf`
		      
		      const mensaje = `Puedes descargar el comprobante de tu pago en el siguiente enlace: ${linkArchivo}`;

		      const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

			async convertPdf2( item ){

	      this.cargar = true;

			  try {


			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('colegiatura.alumno.pdf' , item );

			    const numero = `521${item.telefono}`; // Cambia al número deseado
		      const linkArchivo = `https://sofsolution.club/api-enlace/download-imagenes/${item.idingresos_paquetes}-paquetes`;
		      const mensaje = `Puedes descargar el comprobante de tu pago en el siguiente enlace: ${linkArchivo}`;

		      const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

			async verPdf( item ){

				this.cargar = true;

			  try {

			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('colegiatura.alumno.pdf' , item );

			    let url = `https://sofsolution.club/api-enlace/pdf_pagos/${item.idpagos_grupos_detalles}.pdf`

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

			async verPdfPaquete( item ){

				this.cargar = true;

			  try {

			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('paquete.alumno.pdf' , item );

			    let url = `https://sofsolution.club/api-enlace/pdf_pagos/${item.idingresos_paquetes}-paquetes.pdf`

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

			async verPdfArticulo( item ){

				this.cargar = true;

			  try {

			  	// Si pasa por aquí es que no tiene adeudo
			    const response = await this.$http.post('articulo.alumno.pdf' , item );

			    let url = `https://sofsolution.club/api-enlace/pdf_pagos/${item.idpagos_articulos}-articulos.pdf`

		      // Abre el enlace en una nueva pestaña
		      window.open(url, '_blank');

			  } catch (error) {


			  } finally {

			    this.cargar = false;

			  }

			},

    },
  };
</script>
